// pages/About.js
import React from 'react';
import { Box, Heading } from '@chakra-ui/react';


function About() {
  return (
    <Box>
      <Heading as="h1">About Page</Heading>
      <p>Learn more about us here.</p>
    </Box>
  );
}

export default About;
